import React from 'react';
import { FingotiButton, FingotiModalActions, FingotiModalContent } from '@fingoti/components';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import SvgIcon from '@material-ui/core/SvgIcon';
import AppleIcon from '@material-ui/icons/Apple';
import AndroidOutlinedIcon from '@material-ui/icons/AndroidOutlined';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';

import { datetimeService } from '../../services/datetime.service';
import { sessionService } from '../../services/session.service';

const useStyles = makeStyles((theme) => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '70%',
        },
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'space-evenly',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '50%',
        }
    },
    button: {
        width: '42%',
    },
    noBottomBorder: {
        border: 'none',
    },
    headerCell: {
        border: 'none',
        textAlign: 'right',
        borderRight: '1px solid ' + theme.palette.greyFour.main,
        width: '24%',
        color: theme.palette.greyTwo.main,
    },
    verticalTop: {
        verticalAlign: 'top',
    },
    client: {
        display: 'flex',
        alignItems: 'center',
    },
    clientIcon: {
        marginRight: theme.spacing(2),
        fill: theme.palette.greyTwo.main,
    },

}))

const WindowsIcon = (props) => {
    return (
        <SvgIcon {...props} >
            <path d="M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z" />
        </SvgIcon>
    );
}

export const UserSessionInfo = ({ setOpen, session }) => {

    const classes = useStyles();

    if (!session) {
        return null;
    }

    let icon = <HelpOutlineOutlinedIcon className={classes.clientIcon} />;

    if (sessionService.isWindows(session)) {
        icon = <WindowsIcon className={classes.clientIcon} />
    } else if (sessionService.isAndroid(session)) {
        icon = <AndroidOutlinedIcon className={classes.clientIcon} />;
    } else if (sessionService.isApple(session)) {
        icon = <AppleIcon className={classes.clientIcon} />;
    }

    return (
        <>
            <FingotiModalContent>
                <div className={classes.root}>
                    <TableContainer>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>platform</TableCell>
                                    <TableCell className={`${classes.noBottomBorder} ${classes.client}`}>
                                        {icon} {sessionService.platformLabel(session)}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>browser</TableCell>
                                    <TableCell className={classes.noBottomBorder}>
                                        {[session.browser, session.browserVersion].filter(Boolean).join(' ') || 'Unknown'}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>client</TableCell>
                                    <TableCell className={classes.noBottomBorder}>{session.clientId}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>location</TableCell>
                                    <TableCell className={classes.noBottomBorder}>{sessionService.location(session)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>ip address</TableCell>
                                    <TableCell className={classes.noBottomBorder}>{session.ipAddress || 'Unknown'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>signed in</TableCell>
                                    <TableCell className={classes.noBottomBorder}>{datetimeService.formatDateTimeNoSeconds(new Date(session.authTime))}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>last active</TableCell>
                                    <TableCell className={classes.noBottomBorder}>{datetimeService.formatDateTimeNoSeconds(new Date(session.lastSeenOn))}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </FingotiModalContent>

            <FingotiModalActions>
                <div className={classes.buttonGroup}>
                    <FingotiButton
                        light
                        className={classes.button}
                        onClick={() => setOpen(false)}
                    >
                        Close
                    </FingotiButton>
                </div>
            </FingotiModalActions>
        </>
    );

}
